import React from "react";

import {
  premiumFeatures,
  standardFeatures,
} from "../../configs/OnboardingData";
import { PlanCard } from "./PlanCard";

interface IProps {
  onClose: () => void;
}

export const ZeosUpgrade = ({ onClose }: IProps) => {
  const handleClose = () => {
    onClose();
  };
  const handleUpgrade = (plan: string) => {
    onClose(); // Close modal after upgrade
  };

  return (
    <>
      {/* Header */}
      <div className="w-full text-center mt-6">
        <h2 className="text-4xl text-[#f58220] mb-2">Do More with ZEOS</h2>
        <p className="text-gray-600 mb-8">
          Upgrade your account to get access to next level features.
        </p>
      </div>

      {/* Plan Cards */}
      <div className="grid grid-cols-1 md:grid-cols-2 gap-8 text-left items-stretch">
        <PlanCard
          title="Standard"
          features={standardFeatures}
          className="w-[487px] ml-[-24px]" // moves more to the left
          onClick={() => handleUpgrade("Standard")}
        />
        <PlanCard
          title="Premium"
          features={premiumFeatures}
          className="mr-[-24px]" // moves more to the right
          description="All features of the Basic and Standard plan, plus"
          highlight
          onClick={() => handleUpgrade("Premium")}
        />
        {/* <ZeosButton
          label="No Thanks"
          type="button"
          onPress={handleClose}
          mode="action"
        /> */}
      </div>
    </>
  );
};
